<template>
    <div class="wechatmasscoupon emphasis-back-color">
        <coupon
            :shop_name="shop_name"
            :money="money"
            :full_money="full_money"
            :title="title"
            :begin_date="begin_date"
            :end_date="end_date"
        />
        <van-panel desc="" status="">
            <van-cell slot="header">
                <div class="label-title shop-title">{{ shop_name }}</div>
            </van-cell>
            <van-cell-group>
                <van-cell>
                    <template slot="title">
                        <span class="label-title">地址:</span>
                        <span class="label-content">{{ shop_address }}</span>
                    </template>
                </van-cell>
                <!-- <van-cell>
                    <template slot="title">
                        <span class="label-title">电话:</span>
                        <span class="custom-title">{{ shop_phone }}</span>
                    </template>
                </van-cell> -->
                <van-cell>
                    <template slot="title">
                        <span class="label-title">活动时间:</span>
                        <span class="custom-title">{{ begin_date }}至{{ end_date }}</span>
                    </template>
                </van-cell>
                <van-cell>
                    <template slot="title">
                        <span class="label-title">抢购价格:</span>
                        <span class="custom-title">100</span>
                    </template>
                </van-cell>
            </van-cell-group>
        </van-panel>
        <van-goods-action>
            <div class="spc" />
            <van-goods-action-icon icon="chat-o" text="分享好友" @click="onShare" />
            <van-goods-action-icon icon="chat-o" text="分享朋友圈" @click="onShare" />
            <van-goods-action-button type="danger" text="领取" @click="onReceive" />
            <div class="spc" />
        </van-goods-action>
        <ToShare ref="toshare" />
    </div>
</template>

<script>
import { 
    NavBar,
    Panel, 
    Dialog,
    CellGroup,
    Cell,
    Card, 
    Image,
    Toast,
    Loading, 
    GoodsAction,
    GoodsActionIcon,
    GoodsActionButton
} from 'vant'

import coupon from '@/view/components/coupon'
import { WechatMassCouponApi } from '@/api/wechatmasscoupon'
import { WechatMassCouponRevApi } from '@/api/wechatmasscoupon'
import ToShare from '@/view/components/toshare'
import wxshare from '@/utils/wxshare'
import { getOpenId } from '@/utils/auth'

// eslint-disable-next-line no-unused-vars
// import vConsole from '@/utils/vconsole'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Panel.name]: Panel,
        [Dialog.name]: Dialog,
        [Card.name]: Card,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Toast.name]: Toast,
        [Loading.name]: Loading,
        [Image.name]: Image,
        [GoodsAction.name]:GoodsAction,
        [GoodsActionIcon.name]:GoodsActionIcon,
        [GoodsActionButton.name]:GoodsActionButton,
        ToShare,
        coupon
    },
    data() {
        return {
            id: 0,
            shop_name: '',
            shop_address: '',
            title: '',
            rem: null,
            begin_date: '',
            end_date: '',
            full_money: '',
            money: '',
            allow: 0,
            state: 0,
            loading: false
        }
    },
    mounted() {
        console.log('进来的路由')
        console.log(this.$route)
        console.log(this.$route.params)
        this.id = this.$route.params.id,
        console.log(this.id)
        console.log(this.$route.query)
        console.log(this.$route.query.shared_id)
        this.getData(this.id)
        console.log('show debug')
        
    },
    methods: {
        getData(id) {
            var that = this
            that.loading = true
            that.axios.get(WechatMassCouponApi + id + '/').then((ret) => {
                console.log(ret)
                if (ret.flag) {
                    that.loading = false
                    that.title = ret.details.title
                    that.shop_name = ret.details.shop_name
                    that.shop_address = ret.details.shop_address
                    that.rem = ret.details.note
                    that.begin_date = ret.details.begin_date,
                    that.end_date = ret.details.end_date,
                    that.full_money = ret.details.coupon_data.full_money
                    that.money = ret.details.coupon_data.money
                    that.allow = ret.details.allow
                    that.state = ret.details.state
                    console.log('openid')
                    const openid = getOpenId()
                    console.log(openid)
                    console.log('分享信息')
                    console.log(ret)
                    wxshare.shareItem(`您的好友正在分享${that.title}`, 
                        that.rem, 
                        that.shop_img, 
                        `${window.location.origin}/#/nt/activities/wechatmasscoupon/${that.id}/?shared_id=` + openid )
                } else {
                    console.log(ret.info)
                    this.$router.push({
                        path: '/nt/errorpage',
                        query: {
                            title: '',
                            info: ret.info 
                        }
                    })
                }
            })
        },
        onShare() {
            this.$refs.toshare.show()
        },
        onReceive() {
            var that = this
            that.loading = true
            var postData = {
                id: that.id
            }
            that.axios.post(WechatMassCouponRevApi,postData).then((ret) => {
                that.loading = false
                console.log(ret)
                if (ret.flag) {
                    console.log('ret')
                } else {
                    console.log('ret')
                }
            })
        }
    }
}
</script>

<style lang="less">
.van-button--danger {
    margin-left: 60px;
}
</style>

<style lang="less" scoped>
.wechatmasscoupon {

    .label-title {
        font-weight: bold;
        margin-right: 8px;
    }
    .shop-title {
        text-align: center;
    }
    .spc {
        width: 1em;
    }
}
</style>